// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"84a700a1","787":"ad98bcd2"}[chunkId] + ".chunk.js";
};